//Helpers
const localization = {
  value: (item, market) => {
    return (
      item &&
      item.localizedPropertyDictionary &&
      item.localizedPropertyDictionary[market] &&
      item.localizedPropertyDictionary[market].value
    );
  },
  label: (item, market) => {
    return (
      item &&
      item.localizedPropertyDictionary &&
      item.localizedPropertyDictionary[market] &&
      item.localizedPropertyDictionary[market].label
    );
  },
  unit: (item, market) => {
    return (
      item &&
      item.localizedPropertyDictionary &&
      item.localizedPropertyDictionary[market] &&
      item.localizedPropertyDictionary[market].unit
    );
  },
};

var filtering = {
  market: (item, market) => {
    return item.availableOnCultures.some((language) => {
      return language === market;
    });
  },
  controlsystems: (item, selections) => {
    var hasCompatibleMachineFixing = true,
      hasCompatibleLowerBrackets = true,
      hasCompatibleUpperBrackets = true,
      hasCompatibleControlSystems = true;

    if (selections.machinefixings) {
      hasCompatibleMachineFixing =
        item.compatibleMachineFixings &&
        item.compatibleMachineFixings.find((machinefixing) => {
          return machinefixing === selections.machinefixings.product.name;
        });
    }
    if (selections.upperbrackets) {
      hasCompatibleUpperBrackets =
        item.compatibleUpperBrackets &&
        item.compatibleUpperBrackets.find((upperBracket) => {
          return upperBracket === selections.upperbrackets.product.name;
        });
    }
    if (selections.lowerbrackets) {
      hasCompatibleLowerBrackets =
        item.compatibleLowerBrackets &&
        item.compatibleLowerBrackets.find((lowerBracket) => {
          return lowerBracket === selections.lowerbrackets.product.name;
        });
    }
    if (selections.machine) {
      hasCompatibleControlSystems =
        selections.machine.compatibleControlSystems.some((controlsystem) => {
          return item.name === controlsystem.trim();
        });
    }

    return (
      hasCompatibleControlSystems &&
      hasCompatibleMachineFixing &&
      hasCompatibleLowerBrackets &&
      hasCompatibleUpperBrackets
    );
  },
  supplements: {
    all: (item, selections, market) => {
      if (selections.rototilts) {
        var hasCompatibleRototilt = item.compatibleRototiltNames.some(
          (item) => {
            return item === selections.rototilts.product.name;
          }
        );
      }

      if (item.name === "SecureLock™ for machine coupler") {
        if (selections.machinefixings) {
          var compatibleMachineFixingsPresentation = localization.value(
            item.compatibleMachineFixingsPresentation,
            market
          );
          var compatibleMachineFixingsList =
            compatibleMachineFixingsPresentation.split(",");

          return compatibleMachineFixingsList.some((machinefixing) => {
            //Need to trim because some values looks like "S60,  QC60-4" note the extra space
            return (
              machinefixing.trim() === selections.machinefixings.product.name
            );
          });
        }
      }

      if (item.name === "SecureLock™ for quick coupler") {
        if (selections.lowerbrackets) {
          var compatibleLowerBracketsPresentation = localization.value(
            item.compatibleLowerBracketsPresentation,
            market
          );
          var compatibleLowerBracketsPresentationList =
            compatibleLowerBracketsPresentation.split(",");

          return compatibleLowerBracketsPresentationList.some(
            (lowerbracket) => {
              //Need to trim because some values looks like "S60,  QC60-4" note the extra space
              return (
                lowerbracket.trim() === selections.lowerbrackets.product.name
              );
            }
          );
        }
      }

      if (selections.rototilts) {
        if (!hasCompatibleRototilt) {
          return false;
        }
      }

      return item;
    },
  },
  brackets: {
    all: (item, selections) => {
      var hasCompatibleControlSystem = true;
      if (selections.controlsystems) {
        hasCompatibleControlSystem =
          selections.controlsystems.product.compatibleUpperBrackets.find(
            (upperBracket) => {
              return upperBracket === item.name;
            }
          );
      }
      if (!selections.machinefixings && selections.rototilts) {
        var hasCombinations = selections.rototilts.product.combinations.some(
          (combination) => {
            return (
              hasCompatibleControlSystem &&
              combination.upperBracket === item.name
            );
          }
        );

        if (hasCombinations && hasCompatibleControlSystem) {
          return hasCompatibleControlSystem && item;
        }

        return false;
      } else if (selections.machinefixings) {
        var hasCompatibleUpperbrackets =
          selections.machinefixings.product.compatibleUpperBrackets.some(
            (compatibleupperbracket) => {
              return compatibleupperbracket === item.name;
            }
          );
        return hasCompatibleControlSystem && hasCompatibleUpperbrackets
          ? item
          : false;
      } else {
        return hasCompatibleControlSystem && item;
      }
    },
    lowerbrackets: (products, selections) => {
      return products
        .filter((item) => {
          var hasCompatibleControlSystem = true;
          if (selections.controlsystems) {
            hasCompatibleControlSystem =
              selections.controlsystems.product.compatibleLowerBrackets.find(
                (lowerBracket) => {
                  return lowerBracket === item.name;
                }
              );
          }

          if (selections.rototilts) {
            return (
              hasCompatibleControlSystem &&
              selections.rototilts.product.combinations.some((combination) => {
                return combination.lowerBracket === item.name;
              })
            );
          } else {
            return hasCompatibleControlSystem && item;
          }
        })
        .map((item) => {
          return {
            ...item,
            recommendedLowerbracket:
              selections.upperbrackets &&
              selections.rototilts &&
              selections.rototilts.product.combinations.some((combination) => {
                if (
                  combination.upperBracket ===
                  selections.upperbrackets.product.name
                ) {
                  return combination.lowerBracket === item.name;
                }
                return false;
              }),
          };
        });
    },
    machinefixings: (item, selections, market) => {
      var hasCompatibleControlSystem = true;

      if (selections.machine) {
        var compatibleMachineFixings =
          selections.machine.compatibleMachineFixings.some((machinefixing) => {
            return item.name === machinefixing.trim();
          });
      }

      if (selections.rototilts) {
        var hasCompatibleUpperBrackets;
        if (selections.upperbrackets) {
          hasCompatibleUpperBrackets =
            selections.rototilts.product.combinations.some(() => {
              var compatibleUpperBrackets = localization.value(
                item.compatibleUpperBracketsPresentation,
                market
              );
              //Since the compatibleUpperBracketsPresentation is stored in a string "S60, S80" we need to convert it to an array
              var compatibleUpperBracketsList =
                compatibleUpperBrackets.split(",");

              return compatibleUpperBracketsList.some((upperbracket) => {
                return (
                  selections.upperbrackets.product.name === upperbracket.trim()
                );
              });
            });
        } else {
          hasCompatibleUpperBrackets =
            selections.rototilts.product.combinations.some((combination) => {
              var compatibleUpperBrackets = localization.value(
                item.compatibleUpperBracketsPresentation,
                market
              );
              //Since the compatibleUpperBracketsPresentation is stored in a string "S60, S80" we need to convert it to an array
              var compatibleUpperBracketsList =
                compatibleUpperBrackets.split(",");

              return compatibleUpperBracketsList.some((upperbracket) => {
                return combination.upperBracket === upperbracket.trim();
              });
            });
        }
      }

      if (selections.controlsystems) {
        hasCompatibleControlSystem =
          selections.controlsystems.product.compatibleMachineFixings.find(
            (machinefixing) => {
              return machinefixing === item.name;
            }
          );
      }

      //Returns
      if (selections.machine && !selections.rototilts) {
        return hasCompatibleControlSystem && compatibleMachineFixings;
      }

      if (selections.rototilts && !selections.machine) {
        return hasCompatibleControlSystem && hasCompatibleUpperBrackets;
      }

      if (selections.machine && selections.rototilts) {
        return (
          hasCompatibleControlSystem &&
          compatibleMachineFixings &&
          hasCompatibleUpperBrackets
        );
      }
      return hasCompatibleControlSystem && item;
    },
  },
  tools: {
    all: (item, selections, market) => {
      if (selections.rototilts) {
        var hasCompatibleRototilt =
          item.compatibleRototiltNames &&
          item.compatibleRototiltNames.some((tiltName) => {
            return tiltName === selections.rototilts.product.name;
          });
      }

      var hasWeightRange, minMachineWeight, maxMachineWeight;

      const compatible = () => {
        var buckmins = localization.value(item.minMachineWeight, market);
        var buckmaxs = localization.value(item.maxMachineWeight, market);
        var aa = minMachineWeight + maxMachineWeight;
        var bb = maxMachineWeight - minMachineWeight;
        var cc = aa - bb;
        var dd = buckmins + buckmaxs;
        var ee = buckmaxs - buckmins;
        var ff = dd + ee;
        return ff >= cc && maxMachineWeight > buckmins;
      };

      if (selections.weightrange && !selections.machine) {
        minMachineWeight = selections.weightrange.min;
        maxMachineWeight = selections.weightrange.max;

        hasWeightRange = compatible();
      }

      if (selections.machine) {
        minMachineWeight = localization.value(
          selections.machine.minWeight,
          market
        );
        maxMachineWeight = localization.value(
          selections.machine.maxWeight,
          market
        );

        hasWeightRange = compatible();
      }

      if (selections.lowerbrackets) {
        var hasCompatibleLowerBrackets =
          item.compatibleLowerBrackets &&
          item.compatibleLowerBrackets.some((lowerbracket) => {
            return lowerbracket === selections.lowerbrackets.product.name;
          });
      }

      //Returns
      if (
        !selections.machine &&
        !selections.rototilts &&
        selections.weightrange
      ) {
        return hasWeightRange;
      }

      if (
        !selections.rototilts &&
        selections.machine &&
        selections.lowerbrackets
      ) {
        return hasWeightRange && hasCompatibleLowerBrackets;
      }

      if (selections.rototilts && selections.lowerbrackets) {
        return hasCompatibleRototilt && hasCompatibleLowerBrackets;
      }

      if (selections.rototilts) {
        return hasCompatibleRototilt;
      }

      if (selections.lowerbrackets) {
        return hasCompatibleLowerBrackets;
      }

      if (selections.machine) {
        return hasWeightRange;
      }
      return true;
    },
  },
};

// const getImageLocation = (link) => {
//   return link ? process.env.REACT_APP_URLPATH + "/globalassets/images/general/" + link : "";
// };

const hasUpperBracketsAndNoLowerBrackets = (selections) => {
  if (!selections) {
    return false;
  }

  if (selections.upperbrackets && !selections.lowerbrackets) {
    return true;
  } else {
    return false;
  }
};

const returnSelections = (selections) => {
  return selections;
};

const hasSelections = (selections, skip, skip2, skip3) => {
  if (!selections) {
    return false;
  }

  return Object.keys(selections).some((key) => {
    //Return false when skipped even if its not empty
    if (key === skip || key === skip2 || key === skip3) {
      return false;
    }
    var item = selections[key];

    if (!item) {
      return false;
    }

    if (key === "buckets") {
      return Object.keys(item).some((key) => {
        return Object.entries(item[key]).length > 0 ? true : false;
      });
    }
    //Checks the rest of the entries if it contains any data
    return Object.entries(item).length > 0 ? true : false;
  });
};
const hasTechnicalData = (product, language) => {
  return Object.keys(product).some((key) => {
    var item = product[key];
    //Checks the rest of the entries if it contains any data
    return item &&
      item.localizedPropertyDictionary &&
      item.localizedPropertyDictionary[language] &&
      item.localizedPropertyDictionary[language].value !== null &&
      item.localizedPropertyDictionary[language].value !== ""
      ? true
      : false;
  });
};
const hasGrapplesByType = (products, selections, market, type) => {
  var filteredItems =
    products &&
    products.data.filter((item) =>
      filtering.tools.all(item, selections, market)
    );
  return (
    filteredItems &&
    filteredItems.some((grapple) => {
      return grapple.family.toLowerCase() === type;
    })
  );
};

const hasBucketsByType = (products, selections, market, type) => {
  if (!products) {
    return [];
  }

  var filteredItems =
    products &&
    products.data.filter((item) =>
      filtering.tools.all(item, selections, market)
    );
  return (
    filteredItems &&
    filteredItems.some((bucket) => {
      return bucket.typeWithOutMarket.toLowerCase() === type;
    })
  );
};

const hasFilteredItem = (products, selections, market) => {
  if (!products || !selections || !!market) {
    return false;
  }

  var filteredItems =
    products &&
    products.data.filter((item) =>
      filtering.tools.all(item, selections, market)
    );
  return filteredItems && filteredItems.length > 0 ? true : false;
};

export {
  localization,
  filtering,
  //getImageLocation,
  hasSelections,
  hasGrapplesByType,
  hasBucketsByType,
  hasFilteredItem,
  hasTechnicalData,
  hasUpperBracketsAndNoLowerBrackets,
  returnSelections,
};
